import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ReactSelect from '../../ReactSelect/ReactSelect';
import ReactDOM from 'react-dom';
import { FormGroup } from 'ps-design';
import Input from '../../Input/Input';
import { debounce } from 'ps-shared-ui/v3/debounce';

export default class Responsibilities extends Component {
  static propTypes = {
    addJobDetails: PropTypes.object, // addJob.jobDetails
    JobResponsibilities: PropTypes.array,
    ManagementRole: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    NumberSupervised: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    PeopleTypesManaged: PropTypes.string,
    hireEmployees: PropTypes.bool,
    promoteEmployees: PropTypes.bool,
    terminateEmployees: PropTypes.bool,
    setPay: PropTypes.bool,
    mentorAndAdvise: PropTypes.bool,
    assignEvaluateWork: PropTypes.bool,
    reviewPerformance: PropTypes.bool,

    orgJobTitle: PropTypes.string,
    orgJobCode: PropTypes.string,
    workLocation: PropTypes.string,
    orgJobId: PropTypes.number,
    jobCode: PropTypes.string,
    workLocationExact: PropTypes.string,
    reports: PropTypes.object,
    saveJob: PropTypes.func,
    updatePayReport: PropTypes.func,
    saveJobAndUpdatePay: PropTypes.func,
    quickUpdateJobDetailsAndPay: PropTypes.func,
    display: PropTypes.bool
  };

  constructor(props) {
    const {
      ManagementRole,
      NumberSupervised,
      PeopleTypesManaged,
      hireEmployees,
      promoteEmployees,
      terminateEmployees,
      setPay,
      mentorAndAdvise,
      assignEvaluateWork,
      reviewPerformance
    } = props;
    super(props);

    this.state = {
      isSupervisor: ManagementRole,
      showSupervisorQuestions: ManagementRole,
      numberSupervised: NumberSupervised,
      levelManaged: PeopleTypesManaged,
      hireEmployees: hireEmployees,
      promoteEmployees: promoteEmployees,
      terminateEmployees: terminateEmployees,
      setPay: setPay,
      mentorAndAdvise: mentorAndAdvise,
      assignEvaluateWork: assignEvaluateWork,
      reviewPerformance: reviewPerformance
    };
    this.newState = {};
  }

  componentDidMount() {
    const { JobResponsibilities, addJobDetails } = this.props;

    if (JobResponsibilities) {
      JobResponsibilities.map(answer => {
        const key = answer;
        let val = addJobDetails[answer]; // eslint-disable-line
        const obj = {};
        if (key == 'ManagementRole' && (val == 'No' || val === false)) {
          val = 'No';
          this.setState({ isSupervisor: 'No' });
          this.setState({ showSupervisorQuestions: false });
        } else if (key == 'ManagementRole' && (val == 'Yes' || val)) {
          val = 'Yes';
          this.setState({ isSupervisor: 'Yes' });
          this.setState({ showSupervisorQuestions: true });
        }
        obj[key] = val;
        this.setState(obj);
      });
      this.forceUpdate();
    }
  }

  componentDidUpdate() {
    const { JobResponsibilities, addJobDetails } = this.props;

    if (JobResponsibilities) {
      JobResponsibilities.map(answer => {
        const key = answer;
        let val = addJobDetails[answer]; // eslint-disable-line
        if (key == 'SigningAuthority' && val == 'Yes') {
          const node = ReactDOM.findDOMNode(this.refs.SigningAuthorityAmountAuthorized);
          if (node) {
            node.hidden = false;
          }
        } else if (key == 'SigningAuthority' && val == 'No') {
          const node = ReactDOM.findDOMNode(this.refs.SigningAuthorityAmountAuthorized);
          if (node) {
            node.hidden = true;
          }
        } else if (key == 'SigningAuthority') {
          const node = ReactDOM.findDOMNode(this.refs.SigningAuthorityAmountAuthorized);
          if (node) {
            node.hidden = true;
          }
        }
      });
      if (JobResponsibilities.length == 0) {
        const node = ReactDOM.findDOMNode(this.refs.SigningAuthorityAmountAuthorized);
        if (node) {
          node.hidden = true;
        }
      }
    }
  }

  selectAnswerChange(questionId, value) {
    if (value) {
      const obj = {};
      if (questionId == 'SigningAuthority' && value.value == 'Yes') {
        const node = ReactDOM.findDOMNode(this.refs.SigningAuthorityAmountAuthorized);
        //console.log('dom: ', this.refs.SigningAuthorityAmountAuthorized);
        if (node) {
          node.hidden = false;
        }
      } else if (questionId == 'SigningAuthority') {
        const node = ReactDOM.findDOMNode(this.refs.SigningAuthorityAmountAuthorized);
        if (node) {
          node.hidden = true;
        }
      }
      obj[questionId] = value.value;
      this.setState(obj);
    } else {
      const obj = {};
      if (questionId == 'SigningAuthority') {
        const node = ReactDOM.findDOMNode(this.refs.SigningAuthorityAmountAuthorized);
        if (node) {
          node.hidden = true;
        }
      }
      obj[questionId] = [];
      this.setState(obj);
    }
    const jobDetails = {};
    const currJobDetails = this.props.addJobDetails;
    let jobRespList = currJobDetails.JobResponsibilities; // eslint-disable-line
    if (!jobRespList) {
      jobRespList = [];
    }
    if (!jobRespList.includes(questionId)) {
      jobRespList.push(questionId);
    }
    jobDetails.JobResponsibilities = jobRespList;
    let responsibilitiesList = []; // eslint-disable-line prefer-const
    if (value && value.length) {
      for (let valIdx = 0; valIdx < value.length; valIdx++) {
        responsibilitiesList.push(value[valIdx].value);
      }
    } else if (value && value.value) {
      responsibilitiesList = value.value;
    }
    jobDetails[questionId] = responsibilitiesList;

    this.callSaveJobAndUpdatePay(questionId, responsibilitiesList, jobDetails);
  }

  taskChangeSave(questionId, event) {
    if (!event?.target) {
      return;
    }

    const currJobDetails = this.props.addJobDetails;
    const value = event.target.value;
    if (value === currJobDetails[questionId]) {
      return;
    }

    const jobDetails = {};
    let jobRespList = currJobDetails.JobResponsibilities;
    if (!jobRespList) {
      jobRespList = [];
    }
    if (!jobRespList.includes(questionId)) {
      jobRespList.push(questionId);
    }
    jobDetails.JobResponsibilities = jobRespList;
    jobDetails[questionId] = value;

    this.callSaveJobAndUpdatePay(questionId, value, jobDetails);
  }

  taskChange(questionId, event) {
    if (event && event.target && event.target.value) {
      if (!(event.target.max && event.target.value > parseInt(event.target.max, 10))) {
        const obj = {};
        obj[questionId] = event.target.value;
        this.setState(obj);
      }
    } else {
      const obj = {};
      obj[questionId] = '';
      this.setState(obj);
    }
  }

  changeNumberSupervised(event) {
    if (event && event.target && event.target.value != '') {
      if (parseInt(event.target.value, 10) >= 0) {
        this.newState.numberSupervisedValid = '';
        this.setState({ numberSupervised: parseInt(event.target.value, 10) });
      } else {
        this.newState.numberSupervisedValid = 'error';
      }
    } else {
      this.newState.numberSupervisedValid = 'error';
      this.setState({ numberSupervised: '' });
    }
  }

  onBlurNumberSupervised() {
    if (this.state.numberSupervised === this.props.NumberSupervised) {
      return;
    }

    const jobDetails = {};
    const currJobDetails = this.props.addJobDetails;
    let jobRespList = currJobDetails.JobResponsibilities; // eslint-disable-line
    if (!jobRespList) {
      jobRespList = [];
    }
    if (!jobRespList.includes('NumberSupervised')) {
      jobRespList.push('NumberSupervised');
    }
    jobDetails.JobResponsibilities = jobRespList;
    jobDetails.NumberSupervised = this.state.numberSupervised;

    this.callSaveJobAndUpdatePay('NumberSupervised', this.state.numberSupervised, jobDetails);
  }

  levelManagedOptionsChange(value) {
    if (value) {
      this.setState({ levelManaged: value.value });
      const jobDetails = {};
      const currJobDetails = this.props.addJobDetails;
      let jobRespList = currJobDetails.JobResponsibilities; // eslint-disable-line
      if (!jobRespList) {
        jobRespList = [];
      }
      if (!jobRespList.includes('PeopleTypesManaged')) {
        jobRespList.push('PeopleTypesManaged');
      }
      jobDetails.JobResponsibilities = jobRespList;
      jobDetails.PeopleTypesManaged = value.value;

      this.callSaveJobAndUpdatePay('PeopleTypesManaged', value.value, jobDetails);
    } else {
      this.setState({ levelManaged: '' });
      // Update pay on cleared level managed
      const jobDetails = {};
      const currJobDetails = this.props.addJobDetails;
      let jobRespList = currJobDetails.JobResponsibilities;

      if (!jobRespList) {
        jobRespList = [];
      }
      if (!jobRespList.includes('PeopleTypesManaged')) {
        jobRespList.push('PeopleTypesManaged');
      }
      jobDetails.JobResponsibilities = jobRespList;
      jobDetails.PeopleTypesManaged = '';

      this.callSaveJobAndUpdatePay('PeopleTypesManaged', '', jobDetails);
    }
  }

  jobManagementCheck(event, next) {
    let checkboxValue;
    if (this.state[event.target.id]) {
      checkboxValue = false;
    } else {
      checkboxValue = true;
    }
    const key = event.target.id;
    const val = checkboxValue;
    const obj = {};
    obj[key] = val;
    this.setState(obj);

    const jobDetails = {};
    jobDetails[event.target.id] = checkboxValue;
    const currJobDetails = this.props.addJobDetails;
    currJobDetails[event.target.id] = checkboxValue;
    let jobRespList = currJobDetails.JobResponsibilities; // eslint-disable-line
    if (!jobRespList) {
      jobRespList = [];
    }
    if (!jobRespList.includes('PeopleManagementTasks')) {
      jobRespList.push('PeopleManagementTasks');
    }
    jobDetails.JobResponsibilities = jobRespList;
    const fullTaskList = [
      'Hire employees',
      'Promote employees',
      'Terminate employees',
      'Set pay',
      'Mentor and advise',
      'Assign and evaluate work',
      'Review performance annually'
    ];
    const taskListId = [
      'hireEmployees',
      'promoteEmployees',
      'terminateEmployees',
      'setPay',
      'mentorAndAdvise',
      'assignEvaluateWork',
      'reviewPerformance'
    ];
    let PeopleManagementTasksList = []; // eslint-disable-line prefer-const
    // Let state take care of the current list
    // Also the payscale job info object stores these in two locations :(
    // payscale_job_info.hireEmployees & payscale_job_info.PeopleManagementTasks["Hire Employees"]
    for (let valIdx = 0; valIdx < taskListId.length; valIdx++) {
      const taskName = taskListId[valIdx];
      const name = fullTaskList[valIdx];
      if ((taskName === key && val) || (taskName !== key && this.state[taskName])) {
        PeopleManagementTasksList.push(name);
        jobDetails[taskName] = true;
      } else {
        jobDetails[taskName] = false;
      }
    }

    jobDetails.PeopleManagementTasks = PeopleManagementTasksList;
    if (this.props.isMP) {
      this.debouncedSaveJobUpdatePay('PeopleManagementTasks', PeopleManagementTasksList, jobDetails);
    } else {
      this.quickSaveJobDetailsUpdatePay('PeopleManagementTasks', PeopleManagementTasksList, jobDetails);
    }
  }

  managementTasks() {
    if (this.state.showSupervisorQuestions) {
      return (
        <div className="col-sm-6 people-management__inputs">
          <FormGroup
            text="People Management Tasks"
            labelClassName="add-job__form-headers col-xs-12"
            className="add-job__responsibilities__management"
          >
            <div className="col-xs-6 people-management__column">
              <div className="checkbox add-job__responsibilities__management__checkbox">
                <input
                  type="checkbox"
                  // note: "!!" in front of this.state.hireEmployees converts undefined value to boolean false
                  // "checked" has to be a boolean value and not undefined otherwise it throws warning
                  checked={!!this.state.hireEmployees}
                  className="Hire employees"
                  onChange={this.jobManagementCheck.bind(this)}
                  // jobName="Hire employees"
                  id="hireEmployees"
                />
                <label className="people-management__checkbox-label" htmlFor="hireEmployees">
                  Hire employees
                </label>
              </div>
              <div className="checkbox add-job__responsibilities__management__checkbox">
                <input
                  type="checkbox"
                  checked={!!this.state.promoteEmployees}
                  className=""
                  onChange={this.jobManagementCheck.bind(this)}
                  // jobName="Promote employees"
                  id="promoteEmployees"
                />
                <label className="people-management__checkbox-label" htmlFor="promoteEmployees">
                  Promote employees
                </label>
              </div>
              <div className="checkbox add-job__responsibilities__management__checkbox">
                <input
                  type="checkbox"
                  checked={!!this.state.terminateEmployees}
                  className=""
                  onChange={this.jobManagementCheck.bind(this)}
                  // jobName="Terminate employees"
                  id="terminateEmployees"
                />
                <label className="people-management__checkbox-label" htmlFor="terminateEmployees">
                  Terminate employees
                </label>
              </div>
              <div className="checkbox add-job__responsibilities__management__checkbox">
                <input
                  type="checkbox"
                  checked={!!this.state.setPay}
                  className=""
                  onChange={this.jobManagementCheck.bind(this)}
                  // jobName="Set pay"
                  id="setPay"
                />
                <label className="people-management__checkbox-label" htmlFor="setPay">
                  Set pay
                </label>
              </div>
            </div>
            <div className="col-xs-6 people-management__column">
              <div className="checkbox add-job__responsibilities__management__checkbox">
                <input
                  type="checkbox"
                  checked={!!this.state.mentorAndAdvise}
                  onChange={this.jobManagementCheck.bind(this)}
                  // jobName="Mentor and advise"
                  id="mentorAndAdvise"
                />
                <label className="people-management__checkbox-label" htmlFor="mentorAndAdvise">
                  Mentor and advise
                </label>
              </div>
              <div className="checkbox add-job__responsibilities__management__checkbox">
                <input
                  type="checkbox"
                  checked={!!this.state.assignEvaluateWork}
                  onChange={this.jobManagementCheck.bind(this)}
                  // jobName="Assign and evaluate work"
                  id="assignEvaluateWork"
                />
                <label className="people-management__checkbox-label" htmlFor="assignEvaluateWork">
                  Assign and evaluate work
                </label>
              </div>
              <div className="checkbox add-job__responsibilities__management__checkbox">
                <input
                  type="checkbox"
                  checked={!!this.state.reviewPerformance}
                  onChange={this.jobManagementCheck.bind(this)}
                  // jobName="Review performance annually"
                  id="reviewPerformance"
                />
                <label className="people-management__checkbox-label" htmlFor="reviewPerformance">
                  Review performance annually
                </label>
              </div>
            </div>
          </FormGroup>
        </div>
      );
    }
  }

  buildSupervisorQuestions() {
    const levelManagedOptions = [
      { value: 'Individual/Professional Level', label: 'Individual/Professional Level' },
      { value: 'Supervisory/Professional Level', label: 'Supervisory/Professional Level' },
      { value: 'Middle Management Level', label: 'Middle Management Level' },
      { value: 'Senior Management Level', label: 'Senior Management Level' }
    ];

    if (this.state.showSupervisorQuestions) {
      const supervisedValidClass =
        this.newState.numberSupervisedValid === 'error' ? 'add-job__input--supervised--border' : '';
      return (
        <div>
          <FormGroup
            text="Number Supervised"
            labelClassName="add-job__form-headers"
            className="add-job__responsibilities__inputs number-supervised__input"
          >
            <Input
              type="number"
              min="0"
              value={this.state.numberSupervised}
              onChange={this.changeNumberSupervised.bind(this)}
              onBlur={this.onBlurNumberSupervised.bind(this)}
              className={'add-job__input add-job__input--supervised ' + supervisedValidClass}
            />
          </FormGroup>
          <FormGroup
            text="Highest Level Managed"
            labelClassName="add-job__form-headers"
            className="add-job__responsibilities__inputs"
          >
            <ReactSelect
              className="add-job__responsibilities__level-managed"
              value={levelManagedOptions.filter(({ value }) => value === this.state.levelManaged)}
              options={levelManagedOptions}
              getOptionValue={this.getValue.bind(this)}
              getOptionLabel={this.getLabel.bind(this)}
              onChange={this.levelManagedOptionsChange.bind(this)}
              isClearable={true}
            />
          </FormGroup>
        </div>
      );
    }
  }

  suggestedType(suggestion) {
    let type = suggestion.type ? suggestion.type : 'text';
    if (suggestion.dataType) {
      switch (suggestion.dataType.toLowerCase()) {
        case 'decimal':
        case 'currency':
        case 'int':
          type = 'number';
          break;
        case 'string':
          type = 'text';
          break;
      }
    }
    return type;
  }

  suggestedStep(suggestion) {
    if (
      suggestion.dataType &&
      (suggestion.dataType.toLowerCase() === 'decimal' || suggestion.dataType.toLowerCase() === 'currency')
    ) {
      return 0.01;
    }
    return null;
  }

  getLabel(option) {
    return option.label;
  }

  getValue(option) {
    return option.value;
  }

  buildSigningQuestions(reports) {
    if (reports && reports.validation && reports.validation.suggestions) {
      return reports.validation.suggestions.map((suggestions, index) => {
        if (
          suggestions.answers &&
          suggestions.answers.length > 0 &&
          (suggestions.questionId == 'SigningAuthority' || suggestions.questionId == 'SigningAuthorityAmountAuthorized')
        ) {
          return (
            <FormGroup
              key={suggestions.questionId}
              text={suggestions.questionId.split(/(?=[A-Z])/).join(' ') + ':'}
              labelClassName="add-job__form-headers"
              className={
                'add-job__responsibilities__inputs singleColumn--jobResponsibilities ' + suggestions.questionId
              }
            >
              <ReactSelect
                className="selectCombo__panel"
                value={suggestions.answers.filter(({ value }) => value === this.state[suggestions.questionId])}
                options={suggestions.answers}
                getOptionValue={this.getValue.bind(this)}
                getOptionLabel={this.getLabel.bind(this)}
                onChange={this.selectAnswerChange.bind(this, suggestions.questionId)}
                isClearable={true}
              />
            </FormGroup>
          );
        } else if (
          suggestions.answers &&
          suggestions.answers.length == 0 &&
          (suggestions.questionId == 'SigningAuthority' || suggestions.questionId == 'SigningAuthorityAmountAuthorized')
        ) {
          let type = this.suggestedType(suggestions);
          let step = this.suggestedStep(suggestions);
          return (
            <FormGroup
              ref={suggestions.questionId}
              key={suggestions.questionId}
              text={suggestions.questionId.split(/(?=[A-Z])/).join(' ') + ':'}
              labelClassName="add-job__form-headers"
              className={
                'add-job__responsibilities__inputs singleColumn--jobResponsibilities ' + suggestions.questionId
              }
            >
              <Input
                type={type}
                step={step}
                value={this.state[suggestions.questionId]}
                onChange={this.taskChange.bind(this, suggestions.questionId)}
                onBlur={this.taskChangeSave.bind(this, suggestions.questionId)}
                className="add-job__input"
              />
            </FormGroup>
          );
        }
      });
    }
  }

  buildAdditionalQuestions(reports) {
    if (reports && reports.validation && reports.validation.suggestions) {
      if (reports.validation.suggestions.length <= 3) {
        return reports.validation.suggestions.map((suggestions, index) => {
          if (
            suggestions.answers &&
            suggestions.answers.length > 0 &&
            suggestions.questionId != 'SigningAuthority' &&
            suggestions.questionId != 'SigningAuthorityAmountAuthorized'
          ) {
            return (
              <FormGroup
                text={suggestions.questionId.split(/(?=[A-Z])/).join(' ') + ':'}
                labelClassName="add-job__form-headers"
                key={suggestions.questionId}
                className="col-sm-5 add-job__responsibilities__inputs singleColumn--jobResponsibilities"
              >
                <ReactSelect
                  className="selectCombo__panel"
                  value={suggestions.answers.filter(({ value }) => value === this.state[suggestions.questionId])}
                  options={suggestions.answers}
                  getOptionValue={this.getValue.bind(this)}
                  getOptionLabel={this.getLabel.bind(this)}
                  onChange={this.selectAnswerChange.bind(this, suggestions.questionId)}
                  isClearable={true}
                />
              </FormGroup>
            );
          } else if (
            suggestions.answers &&
            suggestions.answers.length == 0 &&
            suggestions.questionId != 'SigningAuthority' &&
            suggestions.questionId != 'SigningAuthorityAmountAuthorized'
          ) {
            let type = this.suggestedType(suggestions);
            let step = this.suggestedStep(suggestions);
            return (
              <FormGroup
                ref={suggestions.questionId}
                key={suggestions.questionId}
                text={suggestions.questionId.split(/(?=[A-Z])/).join(' ') + ':'}
                labelClassName="add-job__form-headers"
                className="col-sm-5 add-job__responsibilities__inputs"
              >
                <input
                  type={type}
                  step={step}
                  max={suggestions.max ? suggestions.max : null}
                  value={this.state[suggestions.questionId]}
                  onChange={this.taskChange.bind(this, suggestions.questionId)}
                  onBlur={this.taskChangeSave.bind(this, suggestions.questionId)}
                  className="add-job__input add-job__responsibilities__additional-questions__inputs"
                />
              </FormGroup>
            );
          }
        });
      }
      return reports.validation.suggestions.map((suggestions, index) => {
        if (
          suggestions.answers &&
          suggestions.answers.length > 0 &&
          suggestions.questionId != 'SigningAuthority' &&
          suggestions.questionId != 'SigningAuthorityAmountAuthorized'
        ) {
          return (
            <div key={suggestions.questionId} className="col-sm-5">
              <FormGroup
                text={suggestions.questionId.split(/(?=[A-Z])/).join(' ') + ':'}
                labelClassName="add-job__form-headers"
                className="add-job__responsibilities__inputs"
              >
                <ReactSelect
                  className="selectCombo__panel"
                  value={suggestions.answers.filter(({ value }) => value === this.state[suggestions.questionId])}
                  options={suggestions.answers}
                  getOptionValue={this.getValue.bind(this)}
                  getOptionLabel={this.getLabel.bind(this)}
                  onChange={this.selectAnswerChange.bind(this, suggestions.questionId)}
                  isClearable={true}
                />
              </FormGroup>
            </div>
          );
        } else if (
          suggestions.answers &&
          suggestions.answers.length === 0 &&
          suggestions.questionId != 'SigningAuthority' &&
          suggestions.questionId != 'SigningAuthorityAmountAuthorized'
        ) {
          let type = this.suggestedType(suggestions);
          let step = this.suggestedStep(suggestions);
          return (
            <div
              ref={suggestions.questionId}
              key={suggestions.questionId}
              className="col-sm-5 add-job__responsibilities__inputs"
            >
              <FormGroup
                text={suggestions.questionId.split(/(?=[A-Z])/).join(' ') + ':'}
                labelClassName="add-job__form-headers"
              >
                <input
                  type={type}
                  step={step}
                  max={suggestions.max ? suggestions.max : null}
                  value={this.state[suggestions.questionId]}
                  onChange={this.taskChange.bind(this, suggestions.questionId)}
                  onBlur={this.taskChangeSave.bind(this, suggestions.questionId)}
                  className="add-job__input add-job__responsibilities__additional-questions__inputs"
                />
              </FormGroup>
            </div>
          );
        }
      });
    }
  }

  isSupervisorChange(value) {
    const jobDetails = {};
    if (value && value.value == 'Yes') {
      this.setState({ isSupervisor: value.value });
      this.setState({ showSupervisorQuestions: true });
      jobDetails.ManagementRole = 'Yes';
    } else if (value && value.value == 'No') {
      this.setState({ isSupervisor: value.value });
      this.setState({ showSupervisorQuestions: false });
      jobDetails.ManagementRole = 'No';
    } else {
      this.setState({ isSupervisor: value });
      this.setState({ showSupervisorQuestions: false });
      jobDetails.ManagementRole = '';
    }
    const currJobDetails = this.props.addJobDetails;
    let jobRespList = currJobDetails.JobResponsibilities; // eslint-disable-line
    if (!jobRespList) {
      jobRespList = [];
    }
    if (!jobRespList.includes('ManagementRole')) {
      jobRespList.push('ManagementRole');
    }

    jobDetails.JobResponsibilities = jobRespList;

    this.callSaveJobAndUpdatePay('ManagementRole', jobDetails.ManagementRole, jobDetails);
  }

  // helper function, takes in question, value, and jobDetails object which gets merged in by saveJobAndUpdatePay
  callSaveJobAndUpdatePay(questionId, value, jobDetails) {
    const { orgJobTitle, jobCode, workLocationExact, orgJobId, saveJobAndUpdatePay } = this.props;

    saveJobAndUpdatePay(
      {
        orgJobTitle: orgJobTitle,
        orgJobCode: jobCode,
        workLocation: workLocationExact,
        orgJobId: orgJobId,
        jobDetails: jobDetails
      },
      {
        questionId: questionId,
        value: value,
        reportTypes: ['payReport']
      }
    );
  }

  quickSaveJobDetailsUpdatePay = debounce((questionId, value, jobDetails) => {
    const { orgJobTitle, jobCode, workLocationExact, orgJobId, quickUpdateJobDetailsAndPay } = this.props;
    if (!quickUpdateJobDetailsAndPay) {
      this.callSaveJobAndUpdatePay(questionId, value, jobDetails);
    } else {
      quickUpdateJobDetailsAndPay(
        {
          orgJobTitle: orgJobTitle,
          orgJobCode: jobCode,
          workLocation: workLocationExact,
          orgJobId: orgJobId,
          jobDetails: jobDetails
        },
        {
          questionId: questionId,
          value: value,
          reportTypes: ['payReport']
        }
      );
    }
  }, 250);

  debouncedSaveJobUpdatePay = debounce((questionId, value, jobDetails) => {
    this.callSaveJobAndUpdatePay(questionId, value, jobDetails);
  }, 250);

  render() {
    const { reports, display, isMP } = this.props;
    const isSupervisorOptions = [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' }
    ];

    if (display && display !== true) {
      return;
    }

    return (
      <div className="row add-job__responsibilities">
        {!isMP && (
          <h3 className="add-job__all-headers">
            <i className="add-job__experience-heading-icon icon-suitcase" />
            Job and Management Responsibilities
          </h3>
        )}
        <div className="col-sm-12 add-job__responsibilities__container">
          <div className="col-sm-5 supervisor__question-inputs">
            <FormGroup text="Supervisory Role" labelClassName="add-job__form-headers">
              <ReactSelect
                className="add-job__responsibilities__supervisor-dropdown"
                value={isSupervisorOptions.filter(({ value }) => value === this.state.isSupervisor)}
                options={isSupervisorOptions}
                getOptionValue={this.getValue.bind(this)}
                getOptionLabel={this.getLabel.bind(this)}
                onChange={this.isSupervisorChange.bind(this)}
                isClearable={true}
              />
            </FormGroup>
            {this.buildSupervisorQuestions()}
          </div>
          {this.managementTasks()}
          <div className="col-sm-12">{this.buildSigningQuestions(reports)}</div>
          <div className="col-sm-12 add-job__responsibilities__additional-questions">
            {this.buildAdditionalQuestions(reports)}
          </div>
        </div>
      </div>
    );
  }
}
